import script from "./gjcstj.vue?vue&type=script&setup=true&lang=ts"
export * from "./gjcstj.vue?vue&type=script&setup=true&lang=ts"

import "./gjcstj.vue?vue&type=style&index=0&id=2b9b45fc&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b9b45fc"]])

export default __exports__